import { setIotData } from "../redux/BuildingSlice";

export function executeThingsCalls(dispatch, iotCalls) {
  for (const iot in iotCalls) {
    executeThingCall(iotCalls[iot])
      .then((data) => {
        dispatch(setIotData({ data, iot }));
      })
      .catch((e) => console.log(e));
  }
}

export function executeThingCreate(sitemap, data) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const { url } = sitemap;

    httpRequest.open("POST", url);
    httpRequest.setRequestHeader("accept", "application/json");
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.setRequestHeader("X-OPENHAB-TOKEN", sitemap.headers.xOpenhabToken);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send(JSON.stringify(data));
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 201) {
          resolve(httpRequest.status);
        } else {
          reject(httpRequest.responseText || httpRequest.status);
        }
      }
    };
  });
}

export function executeThingUpdate(sitemap, data, uid) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const url = `${sitemap.url}/${uid}`;

    httpRequest.open("PUT", url);
    httpRequest.setRequestHeader("accept", "application/json");
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.setRequestHeader("X-OPENHAB-TOKEN", sitemap.headers.xOpenhabToken);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send(JSON.stringify(data));
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 200) {
          resolve(httpRequest.status);
        } else {
          reject(httpRequest.responseText || httpRequest.status);
        }
      }
    };
  });
}

export function executeThingDelete(sitemap, uid) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const url = `${sitemap.url}/${uid}`;

    httpRequest.open("DELETE", url);
    httpRequest.setRequestHeader("accept", "application/json");
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.setRequestHeader("X-OPENHAB-TOKEN", sitemap.headers.xOpenhabToken);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send();
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4) {
        if ((httpRequest.status === 200) | (httpRequest.status === 202)) {
          resolve(httpRequest.status);
        } else {
          reject(httpRequest.responseText || httpRequest.status);
        }
      }
    };
  });
}

function executeThingCall(sitemap) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const { url } = sitemap;

    httpRequest.open("GET", url);
    httpRequest.setRequestHeader("accept", "application/json");
    httpRequest.setRequestHeader("X-OPENHAB-TOKEN", sitemap.headers.xOpenhabToken);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send();
    httpRequest.onreadystatechange = function () {
      if (this.status === 200) {
        if (this.readyState === 4) {
          const result = JSON.parse(httpRequest.responseText);
          resolve(result.map((e) => ({ ...e, id: e.UID, ...e.statusInfo })));
        }
      } else {
        reject(this.status);
      }
    };
  });
}
